const setSize = function () {
    document.querySelectorAll('.section-head').forEach((el) => {
        if (window.innerWidth > 1180) {
            let beforeHeight =
                el.offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-title')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-lead')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-author')[0]
                .offsetHeight -
                10;
            el.style.setProperty('--beforeSize', beforeHeight + 'px');
        } else if (window.innerWidth < 1180 && window.innerWidth > 880) {
            let beforeHeight =
                el.closest('.article-wrapper').querySelectorAll('.article-title')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-lead')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-author')[0]
                .offsetHeight -
                10;
            
        } else {
            let beforeHeight =
                el.closest('.article-wrapper').querySelectorAll('.article-title')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-lead')[0]
                .offsetHeight +
                el.closest('.article-wrapper').querySelectorAll('.article-author')[0]
                .offsetHeight;
            el.style.setProperty('--beforeTop', el.offsetHeight + 'px');
            el.style.setProperty('--beforeSize', beforeHeight + 'px');
        }
    });
    document.documentElement.style.setProperty(
        '--browserArea',
        window.innerHeight - document.querySelector('.header').offsetHeight + 'px'
    );
};

const setVars = function () {
    document.documentElement.style.setProperty(
        '--windowWidth',
        document.documentElement.clientWidth + 'px'
    );
};

window.addEventListener('DOMContentLoaded', () => {
    setSize();
    setVars();
    document.documentElement.style.setProperty('--textColor', '#333');
    document.documentElement.style.setProperty('--bgColor', '#fff');
});

window.addEventListener('load', () => {
    setSize();
    setVars();
});

let iasd = 0;
let resizeTS = -1;

window.addEventListener('resize', () => {
    if (resizeTS > 0) clearTimeout(resizeTS);
    resizeTS = setTimeout(() => {
        iasd += 1;
        console.log(iasd);
        setSize();
        setVars();
        resizeTS = -1;
    }, 400);
});


//window.addEventListener('resize', (event) => {
////    iasd += 1;
////    console.log(iasd);
//    setSize();
//    setVars();
//});
